export default "__VITE_ASSET__HodW0g6e__"